'use es6';

import { getMetaDataValue, getFormLanguage } from 'FormsUI/selectors/FormDefinition';
import { createSelector } from 'reselect';
import { isEmpty, isEqual, contains } from 'underscore';
import { LegalConsentOptions, ProcessingConsentTypes, LegalConsentKeys, LEGAL_CONSENT_OPTIONS_KEY } from 'FormsCommonComponents/constants/LegalConsent';
import { buildDefaultLegalOptions } from 'FormsCommonComponents/utils/LegalConsent';
import { getFormsLangToLang } from 'FormsUI/utils/Lang';
const root = state => state.legalConsent;
export const getSubscriptionDefinitions = state => root(state).subscriptionDefinitions;
export const getSubscriptionDefinitionsRequestState = state => root(state).subscriptionDefinitionsRequestState;
export const getConsentCopy = state => root(state).consentCopy;
export const getConsentCopyRequestState = state => root(state).consentCopyRequestState;
export const getLegalConsentOptions = state => getMetaDataValue(state, LEGAL_CONSENT_OPTIONS_KEY);
export const getLegalConsentOptionCheckboxes = state => {
  const legalConsentOptions = getLegalConsentOptions(state);
  return legalConsentOptions ? legalConsentOptions.communicationConsentCheckboxes : [];
};
export const getUnselectedSubscriptionDefinitions = createSelector(getLegalConsentOptions, getSubscriptionDefinitions, (legalConsent, definitions) => {
  if (isEmpty(legalConsent)) {
    return [];
  }
  return definitions.filter(({
    id
  }) => {
    const currentIds = legalConsent.get(LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES).map(checkbox => checkbox.communicationTypeId);
    return !contains(currentIds, id);
  });
});
export const getCurrentSelectedLegalConsentOption = createSelector(getLegalConsentOptions, legalConsent => {
  if (isEmpty(legalConsent)) {
    return LegalConsentOptions.NONE;
  }
  const {
    isLegitimateInterest,
    processingConsentType
  } = legalConsent;
  if (isLegitimateInterest) {
    return LegalConsentOptions.LEGITIMATE_INTEREST;
  }
  if (isEqual(processingConsentType, ProcessingConsentTypes.IMPLICIT)) {
    return LegalConsentOptions.IMPLICIT_CONSENT;
  }
  if (isEqual(processingConsentType, ProcessingConsentTypes.REQUIRED_CHECKBOX)) {
    return LegalConsentOptions.SEPERATE_CONSENT;
  }
  return LegalConsentOptions.IMPLICIT_CONSENT;
});
export function getDefaultOptions(state, optionalLang) {
  const lang = isEmpty(optionalLang) ? getFormLanguage(state) : optionalLang;
  const consentCopy = getConsentCopy(state);
  return buildDefaultLegalOptions(getFormsLangToLang(lang), consentCopy);
}